import { inject, Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class ClaimsToastService {
  private readonly messageService = inject(MessageService);

  success(text: string) {
    this.messageService.add({
      severity: 'success',
      summary: 'OK',
      detail: text,
    });
  }

  error(text: string) {
    this.messageService.add({
      severity: 'error',
      summary: 'Fehler',
      detail: text,
    });
  }
}
